/**
 * Created by Administrador on 03/05/2018.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('forgotCtrl', forgotCtrl);

    forgotCtrl.$inject = ['forgotService','$location','messageService', 'AuthServerProvider', 'CONFIG'];

    function forgotCtrl(forgotService,$location,messageService, AuthServerProvider, CONFIG){
        var vm = this;

        vm.submitForgotPassword = function (validForm) {
            vm.urlLogin = $location.$$protocol + "://" + $location.$$host + ":" + $location.$$port;
            AuthServerProvider.login({username: '', password: ''}, true).then(function(responseLogin) {
                forgotService.forgotPassword(vm.user.email, '', CONFIG.DOMAIN_ID,
                    responseLogin.data.access_token)
                    .then(function(result){
                        if(result.data.res === true){
                            messageService.sendEmailPassword('home', vm.user.email);
                            vm.user.email = null;
                        }else{
                            messageService.sendEmailPasswordError('');
                        }
                    });
            });
        }

    }
})();
